import React from 'react';

export enum OfficerAdminAppKeys {
    none = 'none',
    officer = 'officer',
    groupAdmin = 'groupAdmin',
}

export const OfficerAdminContext = React.createContext(OfficerAdminAppKeys.none);